import './style/PaginatedFooter.css';
import React, {useMemo, useRef} from 'react';
import { useLocation } from 'react-router-dom';
import useResponsiveBreakpoint from '../../hooks/ResponseBreakpoint';
import { Navigate, Text } from '@harperai/materialize-design-system';

const PaginatedFooter = ({ page, totalPages, totalResults }) => {
    const { pathname } = useLocation();
    const paginatedFooterRef = useRef(null);
    const paginatedFooterBelowBreakpoint = useResponsiveBreakpoint(paginatedFooterRef, 767, 'width');
    const mobileSized = useMemo(() => paginatedFooterBelowBreakpoint, [paginatedFooterBelowBreakpoint]);

    const MAX_BUTTONS = mobileSized ? 7 : 10;
    const pages = [];

    let startPage = Math.max(page - Math.floor(MAX_BUTTONS / 2), 1);
    let endPage = startPage + MAX_BUTTONS - 1;

    // Adjust startPage and endPage if they exceed boundaries
    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(endPage - MAX_BUTTONS + 1, 1);
    }

    // Generate pages array
    for (let i = (startPage + 1); i < endPage; i++) {
        pages.push(i);
    }

    return (
        <div ref={paginatedFooterRef} className="flex width-100 pad-s justify-center align-center keystone-card-secondary horizontal paginated-footer">
            {!mobileSized && <div className="flex flex-1 pad-s no-pad-top no-pad-bot">
            </div>}
            <div className="flex flex-1 horizontal align-center space-between gap-l">
                <Navigate href={`${pathname}?page=${Number(page) === 0 ? 1 : Number(page)}`} variant="secondary" icon="chevron-left" disabled={Number(page) === 0}/>
                <div className="flex horizontal align-items-end gap-s">
                    {totalPages > 1 && <Navigate href={`${pathname}?page=1`} variant={1 === Number(page) + 1 ? "yellow" : "secondary"}>
                        1
                    </Navigate>}
                    {(Number(page) > 6) && <Text size="caption" variant="secondary" bold={true}>...</Text>}
                    {pages.map(num => (
                        <Navigate key={"footer-page-" + num} index={"footer-page-" + num} href={`${pathname}?page=${num}`} variant={num === Number(page) + 1 ? "yellow" : "secondary"}>
                            {`${num}`}
                        </Navigate>
                    ))}
                    {(Number(page) < (Number(totalPages) - 4)) && <Text size="caption" variant="secondary" bold={true}>...</Text>}
                    <Navigate href={`${pathname}?page=${Number(totalPages)}`} variant={Number(totalPages) === Number(page) + 1 ? "yellow" : "secondary"}>
                        {totalPages}
                    </Navigate>
                </div>
                <Navigate href={`${pathname}?page=${Number(page) === (totalPages - 1) ? totalPages : Number(page) + 2}`} variant="secondary" icon="chevron-right" disabled={Number(page) === (totalPages - 1)}/>
            </div>
            {!mobileSized && <div className="flex flex-1 flex-end pad-s no-pad-top no-pad-bot">
                <Text size="paragraph" variant="secondary" bold={true}>{`${totalResults} Products`}</Text>
            </div>}
        </div>
    );
};

export default PaginatedFooter;